import React from 'react'
import { useIntl } from 'react-intl'
import { PriceUom } from '@/components/ui'
import { formatMoney } from '@/utils/price'
import type { IAgroservicesCardPriceProps } from './types'
import './styles.scss'

export const AgroservicesCardPrice: React.FC<IAgroservicesCardPriceProps> = props => {
  const { price, oldPrice, paymentPeriod } = props

  const intl = useIntl()

  return (
    <div className="agroservicesCardPrice">
      {oldPrice && (
        <h5 className="agroservicesCardPrice__oldPrice">
          {formatMoney(oldPrice.value, intl)} <PriceUom uom={price.uom} />
        </h5>
      )}
      <div className="agroservicesCardPrice__price">
        <span className="h4">
          {formatMoney(price.value, intl)} <PriceUom uom={price.uom} />
        </span>
        &nbsp;
        <span className="agroservicesCardPrice__paymentPeriod">{paymentPeriod}</span>
      </div>
    </div>
  )
}
